import { TextFieldProps as AriaTextFieldProps } from "react-aria-components";
import { ReactNode } from "react";

export enum MDSTextFieldColor {
  Default = "default",
  Blue = "blue",
  Red = "error",
}

export enum MDSTextFieldSlotName {
  LeftAddon = "left",
  RightAddon = "right",
}

interface MDSTextFieldBaseProps extends Omit<AriaTextFieldProps, "children"> {
  /**
   * The kind of text field.
   */
  color?: MDSTextFieldColor;

  /**
   * The placeholder text to display when the field is empty.
   */
  placeholder?: string;

  /**
   * Children to render within the text field.
   */
  children?: ReactNode;
}

export type MDSTextFieldProps =
  | (MDSTextFieldBaseProps & {
      isTextArea?: false;
      textAreaProps?: never;
      inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
    })
  | (MDSTextFieldBaseProps & {
      isTextArea: true;
      textAreaProps?: React.TextareaHTMLAttributes<HTMLTextAreaElement>;
      inputProps?: never;
    });
